import component from "./Text";

export default component;
